import { NavigationItem } from "app/layout/main/components/navigation/types";
import { useFinanceNavigation } from "Finance/navigation";

export const useAppNavigation = (): NavigationItem[] => {
  const financeNavigation = useFinanceNavigation();

  return [...financeNavigation];
};
